import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { FormatDate, FormatDateShort } from "utils/dateUtils";
import "../styles/print.scss";
import { selectState } from "../input.slice";
import { useSelector } from "react-redux";
import { IInput } from "Dashboard/scenes/Consumables/domain/IInput";
import { FormatNumber } from "utils/numberUtils";
import { categoryDictionary } from "utils/translationDictionary";

const PrintInput = () => {
  const memorandumLogo = useMemorandumLogo();
  const { inputs } = useSelector(selectState);

  return (
    <>
      <div className="logo">
        {memorandumLogo && <img src={memorandumLogo} alt="" />}
      </div>
      <h1 className="header-consumables-input">
        Stanje potrošnog materijala na dan:
      </h1>
      <div className="date">{FormatDate(new Date().toISOString())}</div>
      <table className="consumables-input-ts table-header">
        <tbody>
          <tr>
            <th>br. otp. rač</th>
            <th>ime</th>
            <th>dobavljač</th>
            <th>ulaz</th>
            <th>kol ostalo</th>
            <th>datum</th>
          </tr>
        </tbody>
      </table>
      <table className="consumables-input-ts consumables-input-t table-body">
        <tbody>
          {inputs &&
            inputs.map((item: IInput) => (
              <tr key={`${item.inputId}`}>
                <td>{item.billOfLandingId}</td>
                <td className="name">
                  <div>
                    <label>
                      <b>{item.item.name}</b>
                    </label>
                    <label>{categoryDictionary[item.item.category.name]}</label>
                  </div>
                </td>
                <td>{item.supplier.shortName}</td>
                <td>{FormatNumber(item.quantityAmountTotal)}</td>
                <td>
                  <span>
                    <label>{FormatNumber(item.quantityAmountRemaining)}</label>
                    <label>{item.item.latestQuantityUnit.name}</label>
                  </span>
                </td>
                <td>{FormatDateShort(item.date)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default PrintInput;
